<template>
  <div class="container">
    <div class="grid justify-content-center">
      <div class="col-12 ">
        <Card class="centered-card">
          <template #title>
            <div class="text-center text-xl font-bold mb-3">Şifremi Unuttum</div>
            <div class="text-center mb-3">
              <IslemYapiliyor v-if="IslemYapiliyor" />
            </div>
          </template>
          <template #content>
            <div class="field mb-3">
              <InputGroup>
                <InputGroupAddon>
                  <i class="pi pi-at"></i>
                </InputGroupAddon>
                <InputText
                  id="MailAdres"
                  placeholder="Mail Adres"
                  v-model="MailAdres"
                  autofocus
                  :class="{ 'p-invalid': Valid.MailAdres }"
                  :disabled="IslemYapiliyor"
                />
              </InputGroup>
            </div>
            <div v-if="IslemYapiliyor" class="font-light text-xs text-primary mb-3">
              Şifre sıfırlama maili gelmediyse
              <a
                style="cursor: pointer; color: orange; font-weight: 600;"
                @click="handleClick"
              > buraya </a>
              tıklayınız.
            </div>
            <div class="text-center">
              <Button
                label="Gönder"
                @click="handleClick"
                class="w-full"
                :disabled="IslemYapiliyor"
                v-if="!IslemYapiliyor"
              />
            </div>
          </template>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import GlobalServis from "../../../../services/GlobalServis";

export default {
  data() {
    return {
      IslemYapiliyor: false,
      MailAdres: "",
      Valid: {
        MailAdres: false,
      },
    };
  },
  methods: {
    handleClick() {
      if (this._FormCheck()) return;
      this.IslemYapiliyor = true;

      let data = {
        MailAdres: this.MailAdres,
      };

      GlobalServis.GlobalServis("POST", "GetSifreMailGonder", data).then((res) => {
        if (res.status === 200) {
          this.IslemYapiliyor = false;
          // İstersen başarılı mesaj veya yönlendirme ekle
          this.$toast.add({
            severity: "success",
            summary: "Başarılı",
            detail: "Şifre sıfırlama maili gönderildi.",
            life: 3000,
          });
        } else if (res.response.status === 999) {
          this.$toast.add({
            severity: "info",
            summary: "Bilgi",
            detail: res.response.data,
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Hata oldu",
            life: 3000,
          });
          this.IslemYapiliyor = false;
        }
      }).catch(() => {
        this.$toast.add({
          severity: "error",
          summary: "Hata",
          detail: "Sunucu ile bağlantı kurulamadı",
          life: 3000,
        });
        this.IslemYapiliyor = false;
      });
    },
    _FormCheck() {
      if (!this.MailAdres) {
        this.Valid.MailAdres = true;
        this.$toast.add({
          severity: "warn",
          summary: "Uyarı",
          detail: "Mail adresi girin",
          life: 3000,
        });
        return true;
      }
      this.Valid.MailAdres = false;
      return false;
    },
  },
};
</script>

<style scoped>
.container {
  min-height: 100vh;
  background-color: #cdd4cd;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.centered-card {
  width: 100%;
  max-width: 400px;
  padding: 1.5rem;
  box-sizing: border-box;
}

.field {
  width: 100%;
}

.mb-3 {
  margin-bottom: 1rem;
}

/* PrimeVue p-invalid sınıfı input hata rengini verir */
</style>